export const brand = '/src/assets/brand.svg';
export const avarisWordmark = '/src/assets/avaris-wordmark.svg';
export const servicesGradient = '/src/assets/services-gradient.png';
export const philosophyOverlay = '/src/assets/philosophy-overlay.svg';
export const aboutBg = '/src/assets/about-bg.svg';
export const contactGraphic = '/src/assets/contact-graphic.svg';
export const spinGraphic = '/src/assets/spin-graphic.svg';
export const scrollTicks = '/src/assets/scroll-ticks.svg';
